import { render, staticRenderFns } from "./SupplierDialog.vue?vue&type=template&id=a33640f0&scoped=true"
import script from "./SupplierDialog.vue?vue&type=script&lang=js"
export * from "./SupplierDialog.vue?vue&type=script&lang=js"
import style0 from "./SupplierDialog.vue?vue&type=style&index=0&id=a33640f0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33640f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a33640f0')) {
      api.createRecord('a33640f0', component.options)
    } else {
      api.reload('a33640f0', component.options)
    }
    module.hot.accept("./SupplierDialog.vue?vue&type=template&id=a33640f0&scoped=true", function () {
      api.rerender('a33640f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/supplier-prices/SupplierDialog.vue"
export default component.exports